import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS,
  CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET,
  CLEAR_SCIM_TOKEN_SECRET,
  DELETE_SCIM_TOKEN_KEY_SUCCESS,
  GET_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS,
  GET_SCIM_TOKEN_KEY_SUCCESS,
  REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS
} from './actionTypes'

type OrganizationUserProvisioningPageState = {
  accountManagementConnectors: any[]
  webKeys: any[]
}

const initialState: OrganizationUserProvisioningPageState = {
  accountManagementConnectors: [],
  webKeys: []
}

export default function accountManagementConnectorReducer(
  state = initialState,
  action: AnyAction
): OrganizationUserProvisioningPageState {
  switch (action.type) {
    case ADD_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        accountManagementConnectors: [...state.accountManagementConnectors, action.response.connector],
        webKeys: action.response.webKey ? [...state.webKeys, action.response.webKey] : [...state.webKeys]
      }
    }
    case GET_SCIM_TOKEN_KEY_SUCCESS: {
      return action.response ? { ...state, webKeys: [...state.webKeys, action.response] } : state
    }
    case DELETE_SCIM_TOKEN_KEY_SUCCESS: {
      return { ...state, webKeys: state.webKeys.filter(webkeyInstance => webkeyInstance.id !== action.webkeyId) }
    }
    case GET_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        accountManagementConnectors: [...state.accountManagementConnectors, ...action.response]
      }
    }
    case REMOVE_ACCOUNT_MANAGEMENT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        accountManagementConnectors: state.accountManagementConnectors.filter(
          accountManagementConnector => accountManagementConnector.id !== action.accountManagementConnectorId
        )
      }
    }
    case CLEAR_ACCOUNT_MANAGEMENT_CONNECTOR_SECRET: {
      return {
        ...state,
        accountManagementConnectors: state.accountManagementConnectors.map(accountManagementConnector => {
          if (accountManagementConnector.id === action.accountManagementConnectorId) {
            delete accountManagementConnector.clientCredential.clientSecret
          }

          return accountManagementConnector
        })
      }
    }
    case CLEAR_SCIM_TOKEN_SECRET: {
      return {
        ...state,
        webKeys: state.webKeys.map(webKeyInstance => {
          if (webKeyInstance.id === action.webKeyInstanceId) {
            delete webKeyInstance.scimToken
          }

          return webKeyInstance
        })
      }
    }
    default: {
      return state
    }
  }
}
